export default "__VITE_ASSET__B1Rtof9P__"